import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import Toasted from 'vue-toasted';
import VTooltip from 'v-tooltip'
import BootstrapVue from 'bootstrap-vue'
import VueProgressBar from 'vue-progressbar'
import  VueTouch from 'vue-touch'
Vue.use(VueTouch, {name: 'v-touch'})

const progressOptions = {
  color: '#00c9ff',
  failedColor: '#ff7674',
  thickness: '8px',
  transition: {
    speed: '0.5s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'bottom',
  inverse: false
}

Vue.use(VueProgressBar, progressOptions)
// Vue.mixin(routeProgress)


const sweetAlertoptions = {
  confirmButtonColor: '#00c9ff',
  cancelButtonColor: '#ff7674',
  stopKeydownPropagation:false,

};

Vue.use(Toasted)
Vue.use(VueSweetalert2, sweetAlertoptions);
Vue.use(VTooltip)
Vue.use(BootstrapVue)


registerGlobalToasted() // uses vue-tasted
function registerGlobalToasted() {
  let failedOptions = {
    className: 'mToasted',
    type: 'error',
    icon: 'sad-tear',
    duration: 4000,
    position: 'bottom-right',
    iconPack: 'fontawesome'

  };

  Vue.toasted.register('failedRequest',
    (payload) => {
      // if there is no message passed show default message
      if(!payload.message) {
        return 'Oops.. Something Went Wrong..'
      }

      // if there is a message show it with the message
      return 'Oops.. ' + payload.message;
    },
    failedOptions
  )
  let successOptions = {
    className: 'mToasted',
    type: 'success',
    duration: 3000,
    icon: 'smile',
    position: 'bottom-right',
    iconPack: 'fontawesome'

  };

  Vue.toasted.register('successRequest',
    (payload) => {

      // if there is no message passed show default message
      if(!payload.message) {
        return 'Updated succesfully'
      }

      // if there is a message show it with the message
      return 'Successfully ' + payload.message;
    },
    successOptions
  )

  let infoOptions = {
    className: 'mToasted',
    type: 'info',
    duration: 3000,
    icon: {name: 'lightbulb-on'},
    position: 'bottom-right',
    iconPack: 'fontawesome',
    singleton: true

  };
  Vue.toasted.register('info',
    (payload) => {

      // if there is no message passed show default message
      if(!payload.message) {
        return ' '
      }

      // if there is a message show it with the message
      return ' ' + payload.message;
    },
    infoOptions
  )

}